// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "desktop-nav-module--base-text-alt--global--9a3da";
export var baseTextGlobal = "desktop-nav-module--base-text--global--2a5c3";
export var blockSpacing100 = "desktop-nav-module--block-spacing-100--1e429";
export var blockSpacing50 = "desktop-nav-module--block-spacing-50--ddd9b";
export var blockVPadding100 = "desktop-nav-module--block-v-padding-100--e56d2";
export var blockVPadding50 = "desktop-nav-module--block-v-padding-50--0ce30";
export var brandContainer = "desktop-nav-module--brandContainer--9b121";
export var captionTextGlobal = "desktop-nav-module--caption-text--global--7c0a5";
export var cmsRenderedContentGlobal = "desktop-nav-module--cms-rendered-content--global--a124b";
export var container = "desktop-nav-module--container--54479";
export var defaultHSpacingGlobal = "desktop-nav-module--default-h-spacing--global--6ea35";
export var fadeInAnimation = "desktop-nav-module--fadeInAnimation--86db6";
export var fadeInOnLoadGlobal = "desktop-nav-module--fade-in-on-load--global--cea96";
export var fullHeightGlobal = "desktop-nav-module--full-height--global--ed3a5";
export var fullHeightOmittingNavGlobal = "desktop-nav-module--full-height-omitting-nav--global--53a60";
export var headingTextGlobal = "desktop-nav-module--heading-text--global--ac469";
export var ingressTextGlobal = "desktop-nav-module--ingress-text--global--56928";
export var linkColorChangeTransitionGlobal = "desktop-nav-module--link-color-change-transition--global--5430d";
export var linkText = "desktop-nav-module--linkText--eee2f";
export var linkTextTop = "desktop-nav-module--linkTextTop--353b1";
export var mobileNavBarHeight = "85px";
export var navLink = "desktop-nav-module--navLink--db5dc";
export var navMenu = "desktop-nav-module--navMenu--894c6";
export var pageHeadingTextGlobal = "desktop-nav-module--page-heading-text--global--bf517";
export var paragraphTextGlobal = "desktop-nav-module--paragraph-text--global--19249";
export var subheadingTextGlobal = "desktop-nav-module--subheading-text--global--84768";